export const changeDateFormat = (date: string): string => {
  const dateArray = date.split("-");
  if (dateArray.length > 1) {
    return `${dateArray[0]}年${Number(dateArray[1])}月${Number(dateArray[2])}日`;
  }
  return date;
};
